import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { resources } from "./locales";

// Only initialize if not already initialized
if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: "en",
      debug: false,
      interpolation: {
        escapeValue: false,
      },
      detection: {
        lookupQuerystring: "lang",
        order: ["querystring", "localStorage", "cookie", "navigator"],
        caches: ["localStorage", "cookie"],
      },
      // Add these options to prevent hydration issues
      react: {
        useSuspense: false,
      },
    });
}

export default i18n;
